export const FONT_WEIGHTS = [
	{
		key: '100',
		name: '100',
		style: { fontWeight: 100 },
	},
	{
		key: '200',
		name: '200',
		style: { fontWeight: 200 },
	},
	{
		key: '300',
		name: '300',
		style: { fontWeight: 300 },
	},
	{
		key: '400',
		name: '400',
		style: { fontWeight: 400 },
	},
	{
		key: '500',
		name: '500',
		style: { fontWeight: 500 },
	},
	{
		key: '600',
		name: '600',
		style: { fontWeight: 600 },
	},
	{
		key: '700',
		name: '700',
		style: { fontWeight: 700 },
	},
	{
		key: '800',
		name: '800',
		style: { fontWeight: 800 },
	},
	{
		key: '900',
		name: '900',
		style: { fontWeight: 900 },
	},
];

export const TEXT_ALIGNS = [
	{
		key: 'left',
		name: 'Left',
	},
	{
		key: 'center',
		name: 'Center',
	},
	{
		key: 'right',
		name: 'Right',
	},
	{
		key: 'justify',
		name: 'Justify',
	},
];

export const FLEX_ALIGNS = [
	{
		key: 'flex-start',
		name: 'Left',
	},
	{
		key: 'center',
		name: 'Center',
	},
	{
		key: 'flex-end',
		name: 'Right',
	},
];

export const TEXT_TRANSFORMS = [
	{
		key: 'none',
		name: 'Aa',
	},
	{
		key: 'lowercase',
		name: 'aa',
	},
	{
		key: 'uppercase',
		name: 'AA',
	},
];

export const FONT_STYLES = [
	{
		key: 'normal',
		name: 'Normal',
		style: { fontStyle: 'normal' },
	},
	{
		key: 'italic',
		name: 'Italic',
		style: { fontStyle: 'italic' },
	},
];


/**
 * Capability name to be able to update block theme
 */
export const DESIGNER_CAPABILITY = 'spck_design';
